import { Global, Module } from '@nestjs/common'
import { CronService } from './service'
import { DiscoveryModule } from '@nestjs/core'

@Global()
@Module({
	imports: [DiscoveryModule],
	providers: [CronService],
	exports: [CronService],
})
export class CronModule {}

export { CRON_METADATA, CronOptions, Cron } from './cron.decorator'
export { CronService } from './service'
